import dateFormat from "../../../functions/dateFormat";

function DocketsFilterData({data, openNumDocket}) {

    return (
        <div className="InvoicesListTable" style={{ backgroundColor: ' #f0f0f0', height: 'calc(100% - 50px)', overflowY: 'auto', overflowX: 'auto', textAlign: 'center' }}>
            {
             
                Object.keys(data).length > 0 ?

                <table style={{ width: '100%', tableLayout: 'fixed' }}>
                        <thead style={{ position: 'sticky', top: 0, backgroundColor: ' #f2f2f2' }}>
                        <tr>
                            {["מס'", "מס' דוקט", "שם דוקט", "תאריך פתיחה", "עובד"].map((value, key) => (
                                <th key={key}> {value} </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                            {
                                Object.values(data).map((value, key) => (
                                    <tr key={key}>
                                        <td key={1}> {key + 1} </td>
                                        <td key={2} className="docket_number" onClick={() => openNumDocket(value.docket_id)}> {value.docket_id} </td>
                                        <td key={3}> {value.name} </td>
                                        <td key={4}> { dateFormat(value.date) } </td>
                                        <td key={5}> {value.worker} </td>
                                    </tr>
                                ))
                            }
                    </tbody>
                </table>
                :
                <p className={"no-results"}>אין תוצאות</p>
            }
        </div>
    )
}


export default DocketsFilterData;